import { PetPicture, Text, ResponsiveLogo } from '@ui/components'
import React, { useEffect, useMemo } from "react"
import { useAppSelector } from '@front/store'
import { ReactComponent as PencilIcon } from '@/assets/icons/pencil-icon.svg'
import { ReactComponent as Health } from '@/assets/icons/health.svg'
import { ReactComponent as IdBadge } from '@/assets/icons/id_badge.svg'
import { ReactComponent as Vaccine } from '@/assets/icons/vaccine.svg'
import { ReactComponent as CrossIcon } from '@/assets/icons/rounded_cross.svg'
// import { ReactComponent as PendingClockOrangeOutline } from '@/assets/icons/rounded_pending.svg'
import { ReactComponent as PendingClockOrangeOutline } from '@/assets/icons/pending-clock-orange-outline.svg'
import { ReactComponent as StatusOkIcon } from '@/assets/icons/rounded_check.svg'
import { ScrollView, View } from "react-native"
import { t } from 'i18next'
import { useNavigate } from "react-router-dom"
import { usePet, usePetDocumentation, usePetInsurance, useProfile } from '@front/logic'
import { ActiveContainer, ActiveText, ActiveTextBold, BenefitContainer, BenefitsContainer, Container, DatacContainer, QRImage } from "@/aena/styles"
import { HeaderWithBackAena } from '@/components/headerwithback'

interface BenefitItemProps {
  icon: React.JSX.Element
  label: string
  mark: React.JSX.Element
  onPress?: () => void
}

const Passport: React.FC = () => {

  const {
    name,
    avatar: photo,
    qrCode: qrUri,
    benefits: petBenefits,
    hasAllVaccines,
    isVaccinated,
    microchipStatus,
    documentsStatus,
    insuranceStatus,
    hasInsurance,
    hasDocument,
    allowPkpass,
  } = useAppSelector((state) => state.selectedPet)
  const { values: valuesProfile, getCountries, handleSubmit: handleSubmitProfile, getProfileContactInfo } = useProfile()

  const navigate = useNavigate()
  const ownerName = valuesProfile.name
  const ownerLastName = valuesProfile.lastName
  const ownerCardNumber = useAppSelector((state) => state.user.ownerCardNumber)
  const ownerEmail = useAppSelector((state) => state.user.email)
  const petGUID = useAppSelector((state) => state.user.selectedPet)
  const chipUrl = useAppSelector((state) => state.petDocumentation.chip.url)
  console.log('passport-ownerEmail', ownerEmail)
  console.log('passport-ownerCardNumber', ownerCardNumber)
  console.log('passport-petGUID', petGUID)

  const { getPetDetails } = usePet()
  const [hasExternalInsurance, setHasExternalInsurance] = React.useState(false)
  const { getInsurance } = usePetInsurance()

  const miHasDocument = useMemo(() => {
    return !!ownerCardNumber && !!ownerName && !!ownerLastName && !!ownerEmail && !!hasDocument && !!chipUrl
  }, [ownerCardNumber, ownerName, ownerLastName, ownerEmail, chipUrl])

  console.log('miHasDocument', miHasDocument, { ownerCardNumber, ownerName, ownerLastName, ownerEmail, chipUrl, hasDocument })


  useEffect(() => {
    const fetchData = async () => {
      const hasInsurance = async () => {
        const insurance = await getInsurance()
        console.log('insurance', { insurance })
        setHasExternalInsurance(insurance?.hasInsurance ?? false)
      }
      await getPetDetails()
      await getProfileContactInfo()
      await hasInsurance()
    }
    fetchData()
  }, [])


  const onDocumentPress = () => {
    navigate(`documents`)
  }

  const onVaccinePress = () => {
    navigate(`vaccines`)
  }

  const onInsurancePress = async () => {
    navigate(`insurance`)
  }

  const benefits = useMemo(() => {
    if (petBenefits) {
      return [
        {
          icon: <IdBadge width={50} height={50} />,
          label: t('common.documentation'),
          mark: (microchipStatus === "VALIDATED" || documentsStatus === "VALIDATED") ? <StatusOkIcon width={25} height={25} /> : miHasDocument ? <PendingClockOrangeOutline width={25} height={25} /> : <CrossIcon height={25} width={25} />,
          onPress: onDocumentPress,
        },
        {
          icon: <Vaccine width={50} height={50} />,
          label: t('common.vaccines'),
          mark: isVaccinated ? <StatusOkIcon width={25} height={25} /> : hasAllVaccines ? <PendingClockOrangeOutline width={25} height={25} /> : <CrossIcon height={25} width={25} />,
          onPress: onVaccinePress,
        },
        {
          icon: <Health width={50} height={50} />,
          label: t('common.insurance'),
          mark: insuranceStatus === "VALIDATED" ? <StatusOkIcon width={25} height={25} /> : (hasInsurance || hasExternalInsurance) ? <PendingClockOrangeOutline width={25} height={25} /> : <CrossIcon height={25} width={25} />,
          onPress: onInsurancePress,
        },
      ] as unknown as BenefitItemProps[]
    }
    return []
  }, [petBenefits, petGUID, hasAllVaccines, hasInsurance, miHasDocument, hasExternalInsurance])

  const active = useMemo(() => {
    return isVaccinated && (microchipStatus === "VALIDATED" || documentsStatus === "VALIDATED")
    // return isVaccinated && insuranceStatus === "VALIDATED" && microchipStatus === "VALIDATED"
    // return hasAllVaccines && hasInsurance && miHasDocument
  }, [isVaccinated, insuranceStatus, microchipStatus])

  const onPetNamePress = () => {
    navigate('/aena/pet/edit')
  }

  return (
    <React.Fragment>
      <ScrollView>
        <Container style={{ maxWidth: 800, width: '100%', padding: 0, gap: 0 }}>
          <View style={{ flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: 16, gap: 16 }}>
            <ResponsiveLogo
              breakpoint={820}
              hysteresis={20}
              large={{ width: 680, height: 96 }}
              small={{ width: 360, height: 48 }}
            />
          </View>
          <HeaderWithBackAena title={t('common.digitalpetpass')} />

          <DatacContainer>
            <PetPicture
              src={photo}
              isWeb
              onStatePress={onPetNamePress}
              showState={true}
              PencilIcon={<PencilIcon width={15} height={15} />}
            />
            <Text style={{ margin: 10 }} type="H3">{`${t('common.helloim')} ${name}`}</Text>
          </DatacContainer>
          <BenefitsContainer>
            {benefits.map((benefit, index) => (
              <BenefitContainer
                key={index}
                onClick={() => benefit.onPress?.()}
              >
                {/* Container relativo para el ícono principal y el lápiz */}
                <View style={{ position: 'relative', marginTop: 10 }}>
                  {benefit.icon}
                  {/* Lápiz posicionado en la esquina superior derecha del ícono */}
                  <View style={{
                    position: 'absolute',
                    top: -10,
                    right: -20,
                    backgroundColor: 'white',
                    borderRadius: 10,
                    padding: 5,
                    borderColor: 'rgb(22, 59, 108)',
                    borderWidth: 1,
                    shadowColor: '#000',
                    shadowOffset: { width: 0, height: 1 },
                    shadowOpacity: 0.2,
                    shadowRadius: 2,
                    elevation: 2,
                  }}>
                    <PencilIcon width={15} height={15} />
                  </View>
                </View>
                <Text type="cta_medium">{benefit.label}</Text>
                {benefit.mark}
              </BenefitContainer>

            ))}
          </BenefitsContainer>
          {qrUri && (
            <QRImage
              aspectRatio={1}
              source={{
                uri: qrUri,
              }}
              placeHolder={false}
            />
          )}
          <ActiveContainer active={active}>
            <ActiveTextBold type="H3" active={active}>{active ? t('common.petpassidactive') : t('common.petpassidinactive')}</ActiveTextBold>
            <ActiveText type="H5" active={active}>{active ? t('common.alldocumentationcorrect') : t('common.somedocumentationmissing')}</ActiveText>
          </ActiveContainer>
          {/* <ActiveContainer active={active}>
            <ActiveTextBold type="H3" active={active}>{active ? t('common.petpassidactive') : t('common.petpassidinactive')}</ActiveTextBold>
            <ActiveText type="H5" active={active}>{active ? t('common.alldocumentationcorrect') : t('common.somedocumentationmissing')}</ActiveText>
          </ActiveContainer> */}
        </Container>
      </ScrollView>
    </React.Fragment>
  )
};

export default Passport;